// ============================================================================
// CHINESE TRADITIONAL TRANSLATIONS - CHAPTER 3: 耶穌基督
// ============================================================================
// 級別 27-39 (13 級別, 39 問題)

export const chapter3Translations = {
  name: '耶穌基督',
  description: '道成了肉身... 認識基督就是永生',
  
  spiritualWisdom: {
    principle: '認識耶穌基督就是永生',
    scripture: '認識你獨一的真神,並且認識你所差來的耶穌基督,這就是永生 (約翰福音17:3)',
    application: '耶穌生命的每一方面都顯明神,並為永恆滋養我們的靈魂'
  },
  
  levels: {
    27: {
      name: '天使報喜',
      challenge: '天使加百列奉神的差遣往加利利的一座城去...',
      easy: {
        question: '哪位天使向馬利亞報告她將生下耶穌?',
        options: ['米迦勒', '加百列', '拉斐爾', '烏列'],
        hint: '神的使者天使',
        funFact: '👼 加百列意為神的大能 - 偉大宣告的天使!'
      },
      medium: {
        question: '馬利亞對這個宣告的第一反應是什麼?',
        options: [
          '立刻喜悅',
          '完全不信',
          '困惑並問我沒有出嫁,怎麼有這事呢?',
          '恐懼'
        ],
        hint: '一個實際而合理的問題',
        funFact: '🤔 馬利亞提出合理的問題,但對神保持開放的心!'
      },
      hard: {
        question: '馬利亞順服神旨意教導我們什麼?',
        options: [
          '在試煉面前被動',
          '即使不完全明白也信靠的信心',
          '盲目的順服',
          '聽天由命'
        ],
        hint: '是關於即使在未知中也信靠神',
        funFact: '🙏 我是主的使女,情願照你的話成就在我身上 - 信靠信心的榜樣!'
      }
    },
    
    28: {
      name: '降生',
      challenge: '就生了頭胎的兒子,用布包起來,放在馬槽裡...',
      easy: {
        question: '耶穌在哪座城降生?',
        options: ['拿撒勒', '耶路撒冷', '伯利恆', '迦百農'],
        hint: '大衛的城',
        funFact: '🏘️ 伯利恆意為糧倉 - 耶穌,生命的糧!'
      },
      medium: {
        question: '誰最先得到降生的消息?',
        options: [
          '博士',
          '野地裡的牧羊人',
          '聖殿的祭司',
          '馬利亞的家人'
        ],
        hint: '看守羊群的普通人',
        funFact: '🐑 神首先向謙卑的牧羊人宣告 - 給所有人的福音!'
      },
      hard: {
        question: '耶穌降生在馬槽裡象徵什麼?',
        options: [
          '他父母的貧窮',
          '神屈尊就卑來到我們中間的謙卑',
          '缺少地方',
          '鄉村的簡樸'
        ],
        hint: '是關於謙卑中的神聖道成肉身',
        funFact: '👶 宇宙的創造者降生在馬棚裡 - 無限的愛!'
      }
    },

    29: {
      name: '東方博士',
      challenge: '有幾個博士從東方來到耶路撒冷,說...',
      easy: {
        question: '什麼引導博士們找到耶穌?',
        options: ['天使', '星星', '異象', '地圖'],
        hint: '天空中的天體',
        funFact: '⭐ 星象徵耶穌是萬國之光!'
      },
      medium: {
        question: '博士們獻上了什麼禮物?',
        options: [
          '食物',
          '黃金、乳香和沒藥',
          '貴重的衣服',
          '玩具'
        ],
        hint: '三件象徵性和珍貴的禮物',
        funFact: '🎁 黃金(君王)、乳香(神性)、沒藥(犧牲) - 耶穌的全部使命!'
      },
      hard: {
        question: '這些外邦博士在神的計劃中代表什麼?',
        options: [
          '其他宗教的優越性',
          '救恩向所有民族開放的普世性',
          '物質財富',
          '古代科學'
        ],
        hint: '是關於救恩向所有國家開放',
        funFact: '🌍 博士預表將傳遍全世界的福音!'
      }
    },

    30: {
      name: '耶穌受洗',
      challenge: '耶穌受了洗,隨即從水裡上來...',
      easy: {
        question: '誰為耶穌施洗?',
        options: ['彼得', '施洗約翰', '安得烈', '雅各'],
        hint: '耶穌的先鋒',
        funFact: '🌊 施洗約翰認為自己不配給耶穌解鞋帶!'
      },
      medium: {
        question: '耶穌受洗時什麼降在他身上?',
        options: [
          '光',
          '鴿子(聖靈)',
          '天使',
          '只有聲音'
        ],
        hint: '和平的象徵鳥',
        funFact: '🕊️ 鴿子顯明開始事工的神聖膏抹!'
      },
      hard: {
        question: '無罪的耶穌為什麼要受洗?',
        options: [
          '為了作榜樣',
          '為了盡諸般的義並與我們認同',
          '因為宗教義務',
          '為了得赦免'
        ],
        hint: '是關於與有罪人類的團結',
        funFact: '❤️ 耶穌完全認同我們,為了更好地拯救我們!'
      }
    },

    31: {
      name: '曠野受試探',
      challenge: '耶穌被聖靈引到曠野,受魔鬼的試探...',
      easy: {
        question: '耶穌在曠野禁食了多久?',
        options: ['30天', '40天', '50天', '60天'],
        hint: '聖經中試煉的數字',
        funFact: '🏜️ 像摩西和以利亞一樣,40天密集的屬靈預備!'
      },
      medium: {
        question: '耶穌如何拒絕每個試探?',
        options: [
          '靠自己的力量',
          '引用聖經',
          '無視撒但',
          '只是禱告'
        ],
        hint: '卓越的屬靈武器',
        funFact: '📖 經上記著說... - 神的話,聖靈的寶劍!'
      },
      hard: {
        question: '耶穌受試探教導我們什麼關於我們的爭戰?',
        options: [
          '試探就是罪',
          '試探可以通過神的話和信心得勝',
          '必須逃避一切曠野',
          '只有耶穌能抵擋'
        ],
        hint: '是關於我們對抗試探的策略',
        funFact: '⚔️ 耶穌向我們展示如何得勝:神的話 + 積極的信心!'
      }
    },

    32: {
      name: '首批門徒',
      challenge: '耶穌對他們說:來跟從我,我要叫你們得人如得魚一樣...',
      easy: {
        question: '彼得和安得烈的職業是什麼?',
        options: ['牧羊人', '漁夫', '木匠', '稅吏'],
        hint: '加利利海上的職業',
        funFact: '🎣 耶穌將捕魚的漁夫變成得人的漁夫!'
      },
      medium: {
        question: '首批門徒如何回應呼召?',
        options: [
          '猶豫了很久',
          '要求證據',
          '立刻捨下所有跟從他',
          '討價還價'
        ],
        hint: '立即和完全的回應',
        funFact: '🚶 耶穌的權柄如此明顯,他們立刻順服!'
      },
      hard: {
        question: '在我們這個時代跟從耶穌意味著什麼?',
        options: [
          '放棄工作',
          '按照他的教導和旨意生活',
          '加入隔絕的社區',
          '只做傳教'
        ],
        hint: '是關於生命和優先次序的轉變',
        funFact: '✨ 跟從耶穌轉變我們的心、選擇、命運!'
      }
    },

    33: {
      name: '登山寶訓',
      challenge: '虛心的人有福了，因為天國是他們的...',
      easy: {
        question: '登山寶訓中第一個福是什麼？',
        options: [
          '清心的人有福了',
          '虛心的人有福了',
          '溫柔的人有福了',
          '使人和睦的人有福了'
        ],
        hint: '與屬靈謙卑有關',
        funFact: '😊 虛心的人知道他們需要神 - 天國的門戶！'
      },
      medium: {
        question: '耶穌對使人和睦的人說了什麼？',
        options: [
          '他們將會幸運',
          '他們必稱為神的兒子',
          '他們會被愛',
          '他們會強大'
        ],
        hint: '一個特殊的神聖身份',
        funFact: '👑 使人和睦的人像神 - 祂本性的活見證！'
      },
      hard: {
        question: '八福如何顛覆世界的價值觀？',
        options: [
          '透過譴責財富',
          '透過隔離信徒',
          '透過宣告世界鄙視的人有福',
          '透過廢除律法'
        ],
        hint: '這是關於與世俗價值觀相反的神聖價值觀',
        funFact: '🔄 八福改變我們對幸福和成功的看法！'
      }
    },

    34: {
      name: '天國的比喻',
      challenge: '祂用比喻對他們講許多道理...',
      easy: {
        question: '在撒種的比喻中，種子代表什麼？',
        options: [
          '金錢',
          '神的道',
          '善行',
          '愛'
        ],
        hint: '耶穌宣講和教導的',
        funFact: '🌱 神的道在我們心中發芽生長！'
      },
      medium: {
        question: '在芥菜種的比喻中，這粒小種子象徵什麼？',
        options: [
          '人的軟弱',
          '從小開始但變得偉大的天國',
          '細節的重要性',
          '自然'
        ],
        hint: '以驚人的方式成長的東西',
        funFact: '🌳 從最小的種子長出大樹 - 天國的力量！'
      },
      hard: {
        question: '耶穌為什麼用比喻教導？',
        options: [
          '為了使祂的信息複雜化',
          '為了透過熟悉的畫面揭示屬靈真理',
          '因為時間不夠',
          '為了測試智力'
        ],
        hint: '這是關於使天國的奧秘變得可理解',
        funFact: '💡 比喻向敞開的心顯明，向封閉的心隱藏！'
      }
    },

    35: {
      name: '耶穌的神蹟',
      challenge: '祂平靜了風暴，對海說：住了吧！靜了吧！...',
      easy: {
        question: '耶穌用幾個餅餵飽了5000人？',
        options: ['3個餅', '5個餅', '7個餅', '12個餅'],
        hint: '與魚的數量相同',
        funFact: '🍞 5個餅2條魚變成盛宴 - 神聖的慷慨！'
      },
      medium: {
        question: '當耶穌平靜風暴時，門徒說了什麼？',
        options: [
          '祂是魔術師',
          '這是誰，連風和海都聽從祂？',
          '這很正常',
          '我們應該離開這裡'
        ],
        hint: '關於耶穌身份的問題',
        funFact: '⛈️ 連自然元素都認識它們的創造主和主！'
      },
      hard: {
        question: '耶穌神蹟的主要目的是什麼？',
        options: [
          '給眾人留下深刻印象',
          '顯明祂的神性並彰顯神的愛',
          '獲得影響力',
          '僅在物質上幫助'
        ],
        hint: '這是關於神聖啟示和憐憫',
        funFact: '❤️ 每個神蹟都顯明神的心：愛、憐憫、大能！'
      }
    },

    36: {
      name: '登山變像',
      challenge: '祂在他們面前變了形像，臉面明亮如日頭...',
      easy: {
        question: '哪些門徒看見了耶穌變像？',
        options: [
          '全部十二個',
          '彼得、雅各和約翰',
          '只有彼得和約翰',
          '跟隨祂的婦女們'
        ],
        hint: '三人的核心圈子',
        funFact: '⛰️ 彼得、雅各和約翰：神聖榮耀的特權見證人！'
      },
      medium: {
        question: '舊約中哪些人物出現了？',
        options: [
          '亞伯拉罕和以撒',
          '大衛和所羅門',
          '摩西和以利亞',
          '亞當和挪亞'
        ],
        hint: '律法的代表和先知的代表',
        funFact: '📜 摩西（律法）和以利亞（先知）為耶穌作見證！'
      },
      hard: {
        question: '這次變像揭示了耶穌本性的什麼？',
        options: [
          '祂是一位偉大的先知',
          '祂隱藏的神性暫時顯現',
          '祂控制光',
          '祂能改變外貌'
        ],
        hint: '這是關於揭示祂的神性本質',
        funFact: '✨ 耶穌的神聖榮耀閃耀 - 預示祂的復活！'
      }
    },

    37: {
      name: '榮入聖城',
      challenge: '和散那歸於大衛的子孫！奉主名來的是應當稱頌的！...',
      easy: {
        question: '耶穌騎什麼動物進入耶路撒冷？',
        options: ['馬', '驢', '駱駝', '步行'],
        hint: '象徵謙卑與和平的動物',
        funFact: '🐴 驢象徵謙卑的君王以和平而非戰爭來臨！'
      },
      medium: {
        question: '迎接耶穌的群眾喊什麼？',
        options: [
          '國王萬歲！',
          '和散那！奉主名來的是應當稱頌的！',
          '榮耀歸於神！',
          '自由！'
        ],
        hint: '喜樂和祝福的呼喊',
        funFact: '🌿 "和散那"意思是"現在拯救" - 呼求神聖拯救！'
      },
      hard: {
        question: '為什麼這次入城是"榮耀的"卻又是悲劇的？',
        options: [
          '人很少',
          '歡迎祂的群眾5天後會拒絕祂',
          '當局不在',
          '下雨了'
        ],
        hint: '這是關於人心的善變',
        funFact: '💔 同樣的群眾幾天後會喊"釘祂十字架！"'
      }
    },

    38: {
      name: '最後的晚餐',
      challenge: '你們拿著吃，這是我的身體，為你們捨的...',
      easy: {
        question: '耶穌對門徒的腳做了什麼？',
        options: [
          '祝福它們',
          '洗它們',
          '給它們塗香膏',
          '親吻它們'
        ],
        hint: '謙卑和服侍的行為',
        funFact: '🦶 老師成為僕人 - 愛與謙卑的革命！'
      },
      medium: {
        question: '耶穌在這次晚餐中設立了什麼？',
        options: [
          '洗禮',
          '聖餐',
          '主禱文',
          '禁食'
        ],
        hint: '用餅和酒的聖禮',
        funFact: '🍞🍷 餅和酒成為犧牲和愛的永恆象徵！'
      },
      hard: {
        question: '"你們應當如此行，為的是紀念我"是什麼意思？',
        options: [
          '重複這頓晚餐',
          '慶祝我的死和復活直到我再來',
          '記住我的話',
          '彼此相愛'
        ],
        hint: '這是關於活潑的預言性紀念',
        funFact: '⏳ 每次聖餐都宣告主的死，直等到祂來！'
      }
    },

    39: {
      name: '客西馬尼園',
      challenge: '我父啊，倘若可行，求祢叫這杯離開我...',
      easy: {
        question: '耶穌在被捕前在哪裡禱告？',
        options: [
          '在聖殿裡',
          '在客西馬尼園',
          '在橄欖山上',
          '在朋友家'
        ],
        hint: '橄欖樹的園子',
        funFact: '🫒 客西馬尼意思是"榨油坊" - 極度壓力之地！'
      },
      medium: {
        question: '耶穌禱告時門徒做了什麼？',
        options: [
          '與祂一起禱告',
          '睡著了',
          '站崗',
          '離開了'
        ],
        hint: '連一個小時都不能警醒',
        funFact: '😴 心靈固然願意，肉體卻軟弱了 - 人的軟弱！'
      },
      hard: {
        question: '耶穌的痛苦揭示了祂本性的什麼？',
        options: [
          '祂只是人',
          '祂是完全的人也是完全的神',
          '祂懷疑自己的使命',
          '祂軟弱'
        ],
        hint: '這是關於道成肉身的奧秘',
        funFact: '✝️ 耶穌完全承擔人的痛苦，同時對神保持忠誠！'
      }
    }
  }
};

export default chapter3Translations;
